<div class="header">
  <div class="header__inner l-wrapper">
    <div class="header__logo" *ngIf="logoUrl$ | async as logoUrl; else defaultLogo">
      <a routerLink="/" class="logo" aria-label="Navigate to main page" i18n-aria-label="@@NavigateToMainPage">
        <picture class="cover-picture">
          <img ngSrc="{{ logoUrl }}" alt="logo" width="250" height="100">
        </picture>
      </a>
    </div>

    <div class="header__info">
      <app-rest-info></app-rest-info>
    </div>

    <div class="header__nav">
      <app-header-nav></app-header-nav>
    </div>

    <div class="header__right">
      <div class="header__contact" *ngIf="phone$ | async as phone">
        <a href="tel:{{ phone }}" class="contact-phone link link--underline-in h4">{{ phone }}</a>
      </div>

      <ng-container *ngIf="isBasketMode$ | async">
        <div class="header__basket" *ngIf="!isOrderingPage">
          <app-basket-preview></app-basket-preview>
        </div>

        <div class="header__account" *ngIf="isLoyalty$ | async">
          <app-account-preview></app-account-preview>
        </div>
      </ng-container>

      <div class="header__side-menu" *ngIf="breakPoint.isMobile">
        <app-mobile-menu></app-mobile-menu>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultLogo>
  <div class="header__logo">
    <a routerLink="/" class="logo" aria-label="Navigate to main page" i18n-aria-label="@@NavigateToMainPage">
      <picture>
        <img ngSrc="./assets/images/default-logo.png" alt="logo" width="162" height="29">
      </picture>
    </a>
  </div>
</ng-template>
